import Vue from "@/js/project-vue.js";
import ColorViewPlus from "color-view-plus";
import PageIndex from "./PageIndex.vue";
import ProjectUser from "@/js/project-user.js";
import "@/js/page-console.js";

import "@/css/common.css";
import application from "@/js/application.js";
import fontOnline from "font-online";
if (application.profile == "development") {
    fontOnline.sourceHanSans.offline();
} else {
    fontOnline.sourceHanSans.online();
}

Vue.use(ColorViewPlus);

new Vue({
    render: h => h(PageIndex),
    mixins: [ProjectUser]
}).$mount('#page');
